<template>
    <div class="course-container">
        <!--详情-->
        <div class="lesson-container" v-show="this.showMode==='view'">
            <div class="top-title">教科研成果详情</div>
            <div class="info-column-container">
                <div class="flex-item column-title">成果信息</div>
                <div class="flex-item column-status">{{info.achieveTypeName}}</div>
                <div class="flex-item column-btn">
                </div>
            </div>
            <div class="base-info-container">
                <div class="base-info-content">
                    <div class="info-lesson-title">
                        [教科研成果]{{info.achieveTitle}}
                    </div>
                    <div class="info-item-column" style="margin-top: 10px">
                        <div class="info-item-subject">学科信息：{{info.periodName}}、{{info.subjectName}}</div>
                    </div>
                    <div class="info-item-column" v-if="info.achieveTypeName">
                        <div class="info-item-subject">成果类别：{{info.achieveTypeName}}</div>
                    </div>
                    <div class="info-item-column" v-if="info.userName">
                        <div class="info-item-subject">发表人：{{info.userName}}</div>
                    </div>
                    <div class="info-item-column" v-if="info.userOrgName">
                        <div class="info-item-subject">归属组织：{{info.userOrgName}}</div>
                    </div>
                    <div class="info-item-auto">
                        <div class="title-label">成果简介：</div>
                        <div class="content-label"><expendText :text="info.achieveInfo"></expendText></div>
                    </div>
                </div>
                <div class="base-info-cover">
                    <img class="img-100"  :src="info.coverUrl" alt="">
                </div>
            </div>

            <div class="info-column-container" style="margin-bottom: 10px" v-if="info.achieveType != 2&&info.fileList&&info.fileList.length !== 0">
                <div class="column-title">成果附件</div>
            </div>
            <div class="file-list" v-if="info.achieveType != 2&&info.fileList&&info.fileList.length !== 0">
                <div class="file-item" v-for="item in info.fileList" :key="item">
                    <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                    <div class="file-view">
                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                  :src="require('@/assets/file/file_view_color.png')"
                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                        </el-image>
                    </div>
                    <div class="file-view" @click="downloadFile(item)">
                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#ff7f2e"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#ff7f2e"></path></svg>
                    </div>
                </div>
            </div>

            <div class="info-column-container" style="margin-bottom: 10px" v-if="info.achieveType == 2&&info.fileList&&info.fileList.length !== 0">
                <div class="column-title">成果视频</div>
            </div>
            <div class="file-list" v-if="info.achieveType == 2&&info.fileList&&info.fileList.length !== 0">
                <div class="file-item" v-for="item in info.fileList" :key="item">
                    <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                    <div class="file-view" @click="viewVideo(item)">
                        <svg t="1742957219850" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2645" width="24" height="22"><path d="M507.456 64C262.528 64 64 262.752 64 507.904c0 245.12 198.528 443.872 443.456 443.872 244.896 0 443.456-198.752 443.456-443.872C950.912 262.752 752.352 64 507.456 64z m0 843.408c-220.432 0-399.136-178.88-399.136-399.504C108.32 287.2 287.04 108.368 507.456 108.368c220.432 0 399.136 178.88 399.136 399.536 0 220.624-178.704 399.504-399.136 399.504z m201.28-430.96C639.76 429.44 514.656 359.072 443.36 315.52c-29.232-18.496-53.776-11.088-56.144 21.504-1.728 87.248 0 255.52 0 344.32 1.44 33.04 30.592 37.408 55.92 24.08L708.16 544.736c-0.496-0.272 54.272-30.464 0.592-68.288z" fill="#ff7f2e" p-id="2646"></path></svg>
                    </div>
                    <div class="file-view" @click="downloadFile(item)">
                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#ff7f2e"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#ff7f2e"></path></svg>
                    </div>
                </div>
            </div>


            <el-dialog :title="'成果视频'" v-model="isShowVideo" >
                <div class="mb10 cursor">
                    <video controlsList="nodownload"
                           :poster="videoUrl + '?x-oss-process=video/snapshot,t_1,m_fast'"
                           preload="none" controls="controls"
                           style="width: 100%;height: 100%;"
                           :src="videoUrl"></video>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>

import { timestampToTime } from "@/utils/date";
import {downloadFile} from "@/api/adminservice/public";
import { serviceUrl } from "@/utils/global"
import {activityInfo,activityHandleInformation,activityHandleDeleteFile,activityHandleCreate} from "@/api/admin/activity";
import {achieveInfo} from "@/api/admin/achieve";

export default {
    name: "topicInfo",
    components: {},
    props:{
        infoId:{
            type: String,
            default:null,
        },
    },
    watch:{
        infoId(newValue,oldValue){
            this.queryInfo()
        },
    },
    data() {
        return {
            isShowVideo:false,
            serviceUrl,
            token: this.$storage.get("token"),
            viewMode:'view',
            editMode:'edit',
            showMode:'view',
            timestampToTime,
            info:{},
            videoUrl:''
        };
    },
    created() {
    },
    mounted() {
        this.queryInfo()
    },
    computed: {},
    methods: {
        queryInfo(){
            achieveInfo({ achieveId: this.infoId }).then(res => {
                if (res.data.code===1){
                    this.info = res.data.data;
                }
            })
        },
        downloadFile(item){
            downloadFile(item.fileUrl, item.fileName)
        },
        viewVideo(item){
            this.videoUrl = item.fileUrl;
            this.isShowVideo=true;
        },
        handleFIleStatus(status){
            if (status === 1) {
            }else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl,page,){
            const list = [];
            for (let i = 1; i <=page ; i++) {
                list.push(baseUrl+'/' + i+'.png');
            }
            return list;
        },
    }
};
</script>
<style scoped>
.course-container{
    width: 100%;
    height: auto;
    background-color: #fff;
    padding-left: 15px;
    box-sizing: border-box;
    padding-bottom: 10px;
    padding-right: 10px;
    border-radius: 28px;
}
.lesson-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
}
.top-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 18px;
    color: #ff7f2e;
    font-weight: bold;
}
.info-column-container{
    display: flex;
    width: 100%;
    height: 25px;
    border-bottom: 2px solid #ff7f2e;
}
.flex-item:last-child{
    margin-left: auto;
}
.column-title{
    height: 20px;
    line-height: 20px;
    color: #ffbf6b;
    font-weight: bold;
    border-left: 4px solid #ff7f2e;
    font-size: 16px;
    text-indent: 5px;
    width: 100px;
}
.column-status{
    width: 50px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #a2ef4d;
    font-size: 12px;
    text-align: center;
    color: #e87b17;
}
.column-status-fb{
    width: 50px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #e87b17;
    font-size: 12px;
    text-align: center;
    color: #a2ef4d;
}
.column-btn{
    padding-right: 10px;
}
.btn{
    width: auto;
    height: 20px;
    border: 1px solid #ff7f2e;
    color: #ff7f2e;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    border-radius: 4px;
    cursor: pointer;
    padding-left: 5px;
    padding-right: 5px;
}
.base-info-container{
    display: flex;
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    padding-top: 10px;
}
.base-info-content{
    width: calc(100% - 320px);
    padding-right: 20px;
    box-sizing: border-box;
}
.base-info-cover{
    width: 320px;
    height: 224px;
    padding-right: 10px;
    box-sizing: border-box;
    img{
        width: 100%;
        height: 100%;
    }
}
.info-lesson-title{
    width: 100%;
    height: auto;
    font-size: 16px;
    color: #333;
    font-weight: bold;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    padding-right: 100px;
    box-sizing: border-box;

}
.info-item-column{
    display: flex;
    width: 100%;
    height: 24px;
    font-size: 14px;
    line-height: 24px;
    div{
        width: 33.3%;
        font-size: 14px;
        line-height: 24px;
    }
}

.info-lesson-title{
    width: 100%;
    height: auto;
    font-size: 16px;
    color: #333;
    font-weight: bold;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;

}

.info-item-auto{
    width: 100%;
    height: auto;
    line-height: 25px;
    display: flex;
    font-size: 14px;
}

.title-label{
    width: 70px;
}
.content-label{
    width: calc(100% - 70px);
}


.file-list{
    width: 100%;
    height: auto;
}
.file-item{
    display: flex;
    height: 30px;
    width: 100%;
    padding-left: 10px;
    padding-right: 20px;
    box-sizing: border-box;
}
.file-item:hover{
    color: #ff7f2e!important;
    font-weight: bold;
}
.file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
    cursor: pointer;
}
.file-view{
    width: 30px;
    height: 100%;
    cursor: pointer;
}
.file-download{
    width: 30px;
    height: 100%;
}
.file-icon{
    width: 20px;
    height: 20px;
    cursor: pointer;
}


</style>

